<div class="context-menu" #ContextMenuContainer
     *ngIf="IsOpen"
     [style.position]="'fixed'"
     [style.left.px]="Left"
     [style.top.px]="Top">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/context-menu/context-menu.html